import { render, staticRenderFns } from "./showPreviewComponent.vue?vue&type=template&id=08f57186&scoped=true&"
import script from "./showPreviewComponent.vue?vue&type=script&lang=ts&"
export * from "./showPreviewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./showPreviewComponent.vue?vue&type=style&index=0&id=08f57186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f57186",
  null
  
)

export default component.exports